module.exports = __webpack_public_path__ + "img/Left.3941911c.svg";